/**
 * @generated SignedSource<<9ea0eb5d17403ce89e7f9759b04c7cb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PostNoteToTeamsInput = {
  clientMutationId?: string | null;
  conversation?: string | null;
  includeAiSummary?: boolean | null;
  isUser?: boolean | null;
  message: string;
  noteId: string;
  team?: string | null;
};
export type SendNotesModalPostToTeamsMutation$variables = {
  input: PostNoteToTeamsInput;
};
export type SendNotesModalPostToTeamsMutation$data = {
  readonly postNoteToTeams: {
    readonly ok: boolean;
  } | null;
};
export type SendNotesModalPostToTeamsMutation = {
  response: SendNotesModalPostToTeamsMutation$data;
  variables: SendNotesModalPostToTeamsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostNoteToTeamsPayload",
    "kind": "LinkedField",
    "name": "postNoteToTeams",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendNotesModalPostToTeamsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendNotesModalPostToTeamsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "37ce5f5a562e8e26b60c191ef99b8434",
    "id": null,
    "metadata": {},
    "name": "SendNotesModalPostToTeamsMutation",
    "operationKind": "mutation",
    "text": "mutation SendNotesModalPostToTeamsMutation(\n  $input: PostNoteToTeamsInput!\n) {\n  postNoteToTeams(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "30ed046dfdb9992f7127cc9cf87a2832";

export default node;
